import { parse } from 'qs';
import { createSelector } from 'reselect';

var stateSelector = function stateSelector(state) {
  return state.router;
};

var searchSelector = createSelector(stateSelector, function (state) {
  return state.location.search;
});
export var querySelector = createSelector(searchSelector, function (search) {
  return parse(search, {
    ignoreQueryPrefix: true
  });
}); //todo: optimize by using state

export var getQueryParamSelector = function getQueryParamSelector(paramName) {
  return createSelector(querySelector, function (query) {
    return query[paramName];
  });
};
export var pathnameSelector = createSelector(stateSelector, function (state) {
  return state.location.pathname;
});